module.exports = {
    sidebar_width: 0,
};